/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardFeedback } from './ScorecardFeedback.js';
import {
    ScorecardFeedbackFromJSON,
    ScorecardFeedbackFromJSONTyped,
    ScorecardFeedbackToJSON,
} from './ScorecardFeedback.js';

/**
 * 
 * @export
 * @interface GetAllScorecardFeedbacksResponse
 */
export interface GetAllScorecardFeedbacksResponse {
    /**
     * 
     * @type {Array<ScorecardFeedback>}
     * @memberof GetAllScorecardFeedbacksResponse
     */
    data?: Array<ScorecardFeedback>;
    /**
     * 
     * @type {number}
     * @memberof GetAllScorecardFeedbacksResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllScorecardFeedbacksResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllScorecardFeedbacksResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetAllScorecardFeedbacksResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetAllScorecardFeedbacksResponse interface.
 */
export function instanceOfGetAllScorecardFeedbacksResponse(value: object): boolean {
    return true;
}

export function GetAllScorecardFeedbacksResponseFromJSON(json: any): GetAllScorecardFeedbacksResponse {
    return GetAllScorecardFeedbacksResponseFromJSONTyped(json, false);
}

export function GetAllScorecardFeedbacksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllScorecardFeedbacksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScorecardFeedbackFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetAllScorecardFeedbacksResponseToJSON(value?: GetAllScorecardFeedbacksResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScorecardFeedbackToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

